/** Browser-compatible UUID v4 generator. */
export function randomUUID(): string {
  return crypto.randomUUID();
}
